import React from 'react';
import { Promotion } from '@/domains';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { Button } from '@/components/ui/button';
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { createPromotion, updatePromotion } from '@/services/api/promotion';
import { toast } from 'sonner';

const formSchema = z.object({
  days: z.number().min(1),
  discountPercentage: z.number().min(1)
});

export const PromotionForm = ({ promotion, onSave }: { promotion?: Promotion; onSave: (data: any) => void }) => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      days: promotion?.days ?? 0,
      discountPercentage: promotion?.discountPercentage ?? 0
    }
  });

  function onSubmit(values: z.infer<typeof formSchema>) {
    const data = { days: values.days, discountPercentage: values.discountPercentage };

    let request = promotion ? updatePromotion(promotion.id, data) : createPromotion(data);

    request.then(onSave).catch((e) => {
      toast.error(JSON.stringify(e));
    });
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="days"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Consecutive days</FormLabel>
              <FormControl>
                <Input type="number" {...field} onChange={(e) => field.onChange(Number(e.target.value))} />
              </FormControl>
              <FormDescription>Purcahse for multiple days in advance.</FormDescription>

              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="discountPercentage"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Discount percentage</FormLabel>
              <FormControl>
                <Input type="number" {...field} onChange={(e) => field.onChange(Number(e.target.value))} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit">Save</Button>
      </form>
    </Form>
  );
};
